import { getService } from "../../../../../../function/helper";

const getCountries = async set => {
  const response = await getService("/address/v1/country/all");
  const countries = [];

  if (response.status === 200) {
    response.data.data.forEach(item =>
      countries.push({
        value: item.id,
        label: `${item.faName} - ${item.enName}`,
      })
    );
    set(countries);
  }
};

export default getCountries;
